"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAssessmentSnapshotBase = exports.updateAssessmentBase = exports.createAssessmentBase = void 0;
// Based on the Generated ones with only limited output.
exports.createAssessmentBase = `
  mutation CreateAssessment($input: CreateAssessmentInput!) {
    createAssessment(input: $input) {
      id
      status
      description
    }
  }
`;
exports.updateAssessmentBase = `
  mutation UpdateAssessment($id: ID!, $input: UpdateAssessmentInput!) {
    updateAssessment(id: $id, input: $input) {
      id
      status
      description
      isfavorite
    }
  }
`;
exports.createAssessmentSnapshotBase = `
  mutation CreateAssessmentSnapshot($input: CreateSnapshotInput!) {
    createAssessmentSnapshot(input: $input) {
      id
      description
      createdAt
      createdBy
    }
  }
`;
